import { ENRICHMENT_PLATFORM_ACCESS, ENRICHMENT_UNLIMITED_USAGE } from './constants';
export class CurrentUser {
  constructor(data) {
    this.data = data;
  }
  get id() {
    var _this$getUser;
    return ((_this$getUser = this.getUser()) === null || _this$getUser === void 0 ? void 0 : _this$getUser.user_id) || null;
  }
  get portalId() {
    var _this$getPortal;
    return ((_this$getPortal = this.getPortal()) === null || _this$getPortal === void 0 ? void 0 : _this$getPortal.portal_id) || null;
  }
  getData() {
    return this.data;
  }
  getPortal() {
    var _this$getData;
    return (_this$getData = this.getData()) === null || _this$getData === void 0 ? void 0 : _this$getData.portal;
  }
  getUser() {
    var _this$getData2;
    return (_this$getData2 = this.getData()) === null || _this$getData2 === void 0 ? void 0 : _this$getData2.user;
  }
  getGates() {
    var _this$getData3;
    return ((_this$getData3 = this.getData()) === null || _this$getData3 === void 0 ? void 0 : _this$getData3.gates) || [];
  }
  getLimit(limit) {
    return this.getLimits()[limit];
  }
  getLimits() {
    var _this$getPortal2;
    return ((_this$getPortal2 = this.getPortal()) === null || _this$getPortal2 === void 0 ? void 0 : _this$getPortal2.limits) || {};
  }
  getScopes() {
    var _this$getUser2;
    return ((_this$getUser2 = this.getUser()) === null || _this$getUser2 === void 0 ? void 0 : _this$getUser2.scopes) || [];
  }
  hasGate(gate) {
    return this.getGates().includes(gate);
  }
  hasScope(scope) {
    return this.getScopes().includes(scope);
  }
  hasUnlimitedUsagePlan() {
    return this.hasScope(ENRICHMENT_UNLIMITED_USAGE);
  }
  hasCreditsPlan() {
    return this.hasScope(ENRICHMENT_PLATFORM_ACCESS) && !this.hasUnlimitedUsagePlan();
  }
  get isLoaded() {
    return !!this.id || false;
  }
  get isLoading() {
    return !this.isLoaded;
  }
}